module.exports = __webpack_public_path__ + "img/dark_powered-by-olsera.dc01eb79.svg";